export enum columnFetchListTypes {
  FETCH_COLUMN_FETCH_LIST_REQUEST = "FETCH_COLUMN_FETCH_LIST_REQUEST",
  FETCH_COLUMN_FETCH_LIST_SUCCESS = "FETCH_COLUMN_FETCH_LIST_SUCCESS",
  FETCH_COLUMN_FETCH_LIST_FAILURE = "FETCH_COLUMN_FETCH_LIST_FAILURE",
}